var exports = {
  "k": "x127c5a35--f4ae5b--container",
};

module.exports = exports;
